// Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase,
// DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper,
// SplitText, CustomBounce, CustomWiggle,
import { gsap, ScrollTrigger, Flip, CustomEase, CustomWiggle } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, Flip, CustomEase, CustomWiggle);
// expose gsap
window.gsap = gsap;
window.Flip = Flip;
export default () => {
  let mm = gsap.matchMedia();
  //------------------------------------------------------//
  // Setup 🧦 GSAP and register 📜 ScrollTrigger
  // Register more plugins like so: gsap.registerPlugin(ScrollTrigger, splitText);
  // Go to https://greensock.com/docs/v3/Installation?checked=core,scrollTrigger,splitText#installer
  //------------------------------------------------------//
  // gsap.registerPlugin(Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase, DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper, SplitText, CustomBounce, CustomWiggle);

  ScrollTrigger.defaults({
    toggleActions: 'restart pause resume pause',
    markers: window.location.hostname.endsWith('.local') ? true : false
  });

  // END Setup 🧦 GSAP -------------------------------------//

  //--------------------------------//
  // 404
  //--------------------------------//
  if (document.querySelector('.error404')) {
    const container = document.querySelector('.error404 #main-content');
    const ul = document.createElement('ul');
    ul.classList.add('ornaments');
    for (let i = 0; i < 10; i++) {
      const li = document.createElement('li');
      li.textContent = '?';
      ul.appendChild(li);
    }
    container.appendChild(ul);

    gsap.set('.ornaments li', {
      scale: 'random(1, 3)',
      x: `random(0, ${window.innerWidth})`,
      y: window.innerHeight * 1.1,
      opacity: 0
    });

    gsap.to('.ornaments li', {
      xPercent: `random(-150, 150)`,
      yPercent: `random(-150, 150)`,
      duration: 5,
      repeat: 20,
      yoyo: true,
      ease: 'none',
      repeatRefresh: true
    });

    const delay = gsap.utils.random(2, 10, 1, true);

    document.querySelectorAll('.ornaments li').forEach(item => {
      const tl = gsap.timeline({
        repeat: 20
      });

      tl.to(item, {
        delay: () => delay(),
        y: () => `random(${window.innerHeight * 0.1}, ${window.innerHeight * 0.5})`,
        opacity: 1,
        duration: 5,
        ease: 'power1.out'
      });
      tl.to(item, {
        opacity: 0,
        duration: 1
      });
    });
  }

  // END 404 --------------//

  //--------------------------------//
  // 📌 Pin container
  //--------------------------------//
  // add a media query. When it matches, the associated function will run
  mm.add('(min-width: 1250px)', () => {
    document.querySelectorAll('.alloy-pin-container')
      .forEach(function (container) {
        if (container.querySelector('.alloy-sidebar')) {
          const item = container.querySelector('.alloy-sidebar');
          const height = item.querySelector('.size').offsetHeight + 100;
          console.warn(height);
          const timeline = gsap.timeline({
            scrollTrigger: {
              trigger: container,
              scrub: 0.5,
              start: 'top top',
              end: `bottom ${height}px`,
              pin: item,
              pinSpacing: false,
            }
          });
        }
      });
  });
  // END Animation ELEMENT -------------------------------------//
  // END 📌 Pin container --------------//
  //--------------------------------//
  // Meta filter 
  //--------------------------------//
  // on .single of there is a .meta-container I want to hide all li items in .list exect the fiirst two. If this is the case I Want to show a button that says toggle which shows the hidden item in the list 
  if (document.querySelector('.single .meta-container')) {
    const metaContainer = document.querySelector('.single .meta-container');
    const list = metaContainer.querySelectorAll('.list');

    function updateMetaList() {
      // Capture states before any changes
      const containerState = Flip.getState(metaContainer);

      // Track which items are changing state
      const changingItems = [];

      document.querySelectorAll('.filter-item').forEach(item => {
        const wasHidden = item.style.display === 'none';
        const willBeHidden = item.classList.contains('hide-filter-item');

        // Only track items that are actually changing state
        if (wasHidden !== willBeHidden) {
          changingItems.push({
            element: item,
            entering: !willBeHidden // true if becoming visible, false if becoming hidden
          });
        }

        // Update display state
        if (willBeHidden) {
          item.style.display = 'none';
        } else {
          // If item is becoming visible, set initial hidden state
          if (wasHidden) {
            gsap.set(item, { opacity: 0, scale: 0 });
          }
          item.style.display = 'block';
        }
      });

      // Animate container height first (fast)
      Flip.from(containerState, {
        duration: 0.3,
        ease: "power2.out"
      });

      // Only animate items that are actually changing state
      if (changingItems.length > 0) {
        // gsap.delayedCall(0.25, () => {
        changingItems.forEach((itemData, index) => {
          if (itemData.entering) {
            // Item is becoming visible
            gsap.fromTo(itemData.element, {
              opacity: 0,
              scale: 0,
            }, {
              opacity: 1,
              scale: 1,
              duration: 0.2,
              // delay: index * 0.05,
              transformOrigin: 'top left',
              // ease: "power1.inOut"
            });
          } else {
            // Item is becoming hidden
            gsap.to(itemData.element, {
              opacity: 0,
              scale: 0,
              duration: 0.3,
              // delay: index * 0.05,
              transformOrigin: 'top left',
              // ease: "power1.inOut"
            });
          }
        });
        // });
      }
    }
    list.forEach(item => {
      // gsap to array using gsap.utils.toArray
      const li = gsap.utils.toArray(item.querySelectorAll('li'));

      // remove the first two li items
      if (li.length > 2) {
        li.slice(2).forEach(itemEl => {
          itemEl.classList.add('toggle-meta-list-item');
          itemEl.classList.add('hide-filter-item');
          // itemEl.classList.add('filter-item');
        });
        // add list item with class .more and text ...
        metaContainer.classList.add('has-toggle-meta-list');
        const more = document.createElement('li');
        more.classList.add('show-more');
        more.classList.add('more');
        more.classList.add('filter-item');
        more.textContent = '...';
        item.appendChild(more);

      }
    });

    // Initialize with flip animation after setting up classes
    updateMetaList();
    // get .toggle-meta-list
    const toggle = metaContainer.querySelector('.toggle-meta-list');

    toggle.addEventListener('click', () => {
      // toggle between text open and close
      toggle.textContent = toggle.textContent === toggle.dataset.textOpen ? toggle.dataset.textClose : toggle.dataset.textOpen;
      document.querySelectorAll('.toggle-meta-list-item').forEach(itemEl => {
        itemEl.classList.toggle('hide-filter-item');
      });
      document.querySelectorAll('.more').forEach(itemEl => {
        itemEl.classList.toggle('show-more');
        itemEl.classList.toggle('hide-filter-item');
      });

      // Update animations after class changes
      updateMetaList();
    });
  }
  // END Meta filter --------------//

  //--------------------------------//
  // scroll to animation  
  //--------------------------------//

  // only run if user has not reduced motion using gsap mm 
  mm.add('(prefers-reduced-motion: no-preference)', () => {

    const wiggles = 10; //tweak this to whatever number you want. 

    CustomWiggle.create("Wiggle.anticipate", { wiggles: wiggles, type: "anticipate" });

    document.querySelectorAll('.scroll-down').forEach(item => {
      const q = gsap.utils.selector(item);
      const tl = gsap.timeline({
        repeat: -1,
        repeatDelay: 7,
      });
      tl.to(item, {
        y: 50,
        duration: 3,
        ease: 'Wiggle.anticipate',
      });
    });
    // END scroll to animation  --------------//

  });

};
